<app-header></app-header>
<div class="containers">
  <!-- <div class="left-panel">
    <h2><strong>FuProp</strong></h2>
    <p  class="settings">Where Property Deals Are</p><br>
    <p><strong>Direct</strong> &nbsp;<span class="settings"
        >and</span>&nbsp;
      <strong>Effortless</strong></p>
    <ul>
      <li>✔ Free Property Listings</li>
      <li>✔ Free Access to Contact Details</li>
      <li>✔ Expert-Led Real Estate Services</li>
      <li>✔ Zero Brokerage</li>
    </ul>
  </div> -->

  <div class="left-panel">
  <h2><strong>FuProp</strong></h2>
  <p class="settings">Simplifying Property Deals — Fast, Free & Transparent</p>
  <br>
  <p class="font_check">
    <strong>Direct</strong> access to owners and buyers, with an <strong>Effortless</strong> property discovery experience.
  </p>

  <!-- <p class="font_check">
    FuProp empowers you to buy, sell, or rent properties without agents or hidden charges. Our platform offers a hassle-free,
    commission-free experience designed to make real estate transactions simpler and smarter.
  </p> -->

  <ul>
    <li>✔ <strong>List Properties for Free</strong> — Residential & commercial.</li>
    <li>✔ <strong>Free Access to Contact Info</strong> — Talk directly, no paywalls.</li>
    <li>✔ <strong>Professional Guidance</strong> — Expert support when you need it.</li>
    <li>✔ <strong>Zero Brokerage</strong> — Save more on every deal.</li>
  </ul>
<!--
  <p class="font_check">
    With FuProp, finding or listing a property becomes seamless — no middlemen, no complications. Just direct, trustworthy connections.
  </p> -->
</div>


  <div class="right-panelpro">
    <div class="right-panel">

      <!-- Login -->
      <form *ngIf="showLogin" [formGroup]="loginForm"
        (ngSubmit)="onLoginSubmit()">
        <h2>Login</h2>

        <label class="labels">Email</label>
        <input type="email" formControlName="emailusernam"
          placeholder="Enter Email">
        <div class="error"
          *ngIf="loginForm.get('emailusernam')?.touched && loginForm.get('emailusernam')?.invalid">
          <small *ngIf="loginForm.get('emailusernam')?.errors?.['required']">Email is
            required.</small>
          <small *ngIf="loginForm.get('emailusernam')?.errors?.['emailusernam']">Invalid email
            format.</small>
        </div>

        <label class="labels">Password</label>
        <div class="password-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            formControlName="loginpassword"
            placeholder="Enter Password">
          <i
            class="fa"
            [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
            (click)="showPassword = !showPassword"></i>
        </div>
        <div class="error"
          *ngIf="loginForm.get('loginpassword')?.touched && loginForm.get('loginpassword')?.invalid">
          <small
            *ngIf="loginForm.get('loginpassword')?.errors?.['required']">Password is
            required.</small>
        </div>

        <div class="forgot" (click)="toggle('forgot')">Forgot Password?</div>
        <button type="submit" class="setbutton">Login</button>
        <div class="loginlast">New to FuProp?
          <span style="color: #004aad; cursor: pointer;"
            (click)="toggle('signup')">SignUp</span>
        </div>
      </form>

      <!-- Signup -->
      <form *ngIf="showSignup" [formGroup]="signupForm"
        (ngSubmit)="onSignupSubmit()">
        <h2>Create Your Account</h2>

        <div class="radio-group">
          <label>
            <input type="radio" formControlName="role" value="Individual">
            <span style="color: #323131;">Individual</span>
          </label>
          <label>
            <input type="radio" formControlName="role" value="Builder">
            <span style="color: #323131;">Builder</span>
          </label>
          <label>
            <input type="radio" formControlName="role" value="Dealer">
            <span style="color: #323131;">Dealer</span>
          </label>
        </div>

        <label class="labels">Name</label>
        <input type="text" formControlName="fullName"
          placeholder="Enter Name"  (input)="onInput($event)">
        <div class="error"
          *ngIf="signupForm.get('fullName')?.touched && signupForm.get('fullName')?.invalid">
          <small *ngIf="signupForm.get('fullName')?.errors?.['required']">
            Name is required.</small>
        </div>

        <label class="labels">Email</label>
        <input type="email" formControlName="email"
          placeholder="Enter Email">
        <div class="error"
          *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.invalid">
          <small *ngIf="signupForm.get('email')?.errors?.['required']">Email is
            required.</small>
          <small *ngIf="signupForm.get('email')?.errors?.['email']">Invalid
            email format.</small>
        </div>

        <label class="labels">Password</label>
        <div class="password-wrapper">
          <input
            [type]="showSignupPassword ? 'text' : 'password'"
            formControlName="password"
            placeholder="Enter Password">
          <i
            class="fa"
            [ngClass]="showSignupPassword ? 'fa-eye-slash' : 'fa-eye'"
            (click)="showSignupPassword = !showSignupPassword"></i>
        </div>
        <div class="error"
          *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid">
          <small
            *ngIf="loginForm.get('password')?.errors?.['required']">Password is
            required.</small>
        </div>

        <div style="color:#323131; font-size: 20px;">
          <input type="checkbox" formControlName="termsAccepted"
            style="width: 15px;height:14px;">
          I Agree to all
          <div class="term"><a href="/#/termsandcondition" target="_blank" rel="noopener noreferrer">T&C</a><span style="color: #323131;">&nbsp;and&nbsp;</span>  <a href="/#/privacyPolicy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></div>
          </div>
        <div class="error"
          *ngIf="signupForm.get('termsAccepted')?.touched && signupForm.get('termsAccepted')?.invalid">
          <small
            *ngIf="signupForm.get('termsAccepted')?.errors?.['requiredTrue']">You
            must accept the terms.</small>
        </div>

        <button type="submit" class="setbutton">Sign Up</button>
        <div class="loginlast">Already have an account?
          <span style="color: #004aad; cursor: pointer;"
            (click)="toggle('login')">Sign In</span>
        </div>
      </form>

      <!-- Forgot Password -->
      <form *ngIf="showForgot" [formGroup]="forgotForm"
        (ngSubmit)="onForgotSubmit()">
        <h2>Forgot Password</h2>

        <input type="email" formControlName="forgotemail"
          placeholder="Enter Email">
        <div class="error"
          *ngIf="forgotForm.get('forgotemail')?.touched && forgotForm.get('forgotemail')?.invalid">
          <small *ngIf="forgotForm.get('forgotemail')?.errors?.['required']">Email is
            required.</small>
          <small *ngIf="forgotForm.get('forgotemail')?.errors?.['forgotemail']">Invalid
            email format.</small>
        </div>

        <button type="submit" class="setbutton">Send OTP</button>
        <div class="loginlast" style="color: #004aad; cursor: pointer;"
          (click)="toggle('login')">Back to Login</div>
      </form>

    </div>
  </div>
</div>
